import { jsx as f } from "react/jsx-runtime";
import n from "./index.es5736.js";
import { uniqueId as d } from "lodash/fp";
import { RightControls as p } from "./index.es5737.js";
import { LeftControls as c } from "./index.es5738.js";
const l = ({
  children: e,
  "aria-label": o,
  "aria-labelledby": r,
  title: t,
  id: i,
  ...a
}) => {
  const s = d(i || "modal-footer"), m = o || r || t ? { "aria-label": o, "aria-labelledby": r, title: t } : { "aria-label": `Modal footer ${s}` };
  return /* @__PURE__ */ f("div", { className: n.footer, role: "region", ...m, ...a, children: e });
};
l.RightControls = p;
l.LeftControls = c;
export {
  l as ModalFooter
};
//# sourceMappingURL=index.es870.js.map
